var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShippedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none",
  viewBox: "0 0 16 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#176f69",
  fillRule: "evenodd",
  d: "M1.914 1.984V8.13h.602a1.839 1.839 0 1 1-.4 1.1h-.302a1 1 0 0 1-1-1V1.884a1 1 0 0 1 1-1h7.794a1 1 0 0 1 1 1v1.29h2.078a2.5 2.5 0 0 1 2.5 2.5V8.73a.5.5 0 0 1-.5.5h-1.465v.048a1.839 1.839 0 1 1-3.676-.046H5.792a1.83 1.83 0 0 0-.4-1.1h4.116V1.984zm8.705 2.29h.758v1.448a.8.8 0 0 0 .8.8h1.909V8.13H12.82a1.835 1.835 0 0 0-2.201-.525zm1.858 1.148V4.274h.209a1.4 1.4 0 0 1 1.377 1.148zm-1.094 4.594a.739.739 0 1 0 0-1.478.739.739 0 0 0 0 1.478m-6.69-.739a.739.739 0 1 1-1.478 0 .739.739 0 0 1 1.478 0",
  clipRule: "evenodd"
})));
export { SvgShippedIcon as ReactComponent };